import api from './api';

export interface PromotionCode {
  id: string;
  code: string;
  isManaged: boolean;
  stripePromotionCodeId?: string;
  stripeCouponId?: string;
  discountType: 'Percentage' | 'FixedAmount' | 'TrialDays';
  discountValue: number;
  trialPeriodDays?: number;
  durationInMonths?: number;
  maxRedemptions?: number;
  timesRedeemed: number;
  isActive: boolean;
  expiresAt?: string;
  createdAt: string;
  description: string;
  isComplementary: boolean;
}

export interface CreatePromotionCodeDto {
  code: string;
  isManaged: boolean;
  discountType: 'Percentage' | 'FixedAmount' | 'TrialDays';
  discountValue: number;
  trialPeriodDays?: number;
  durationInMonths?: number;
  maxRedemptions?: number;
  expiresAt?: string;
}

export interface PromotionCodeValidation {
  isValid: boolean;
  errorMessage?: string;
  promotionCode?: PromotionCode;
}

export const getAllPromotionCodes = async (): Promise<PromotionCode[]> => {
  const response = await api.get<PromotionCode[]>('/promotion-codes');
  return response.data;
};

export const createPromotionCode = async (dto: CreatePromotionCodeDto): Promise<PromotionCode> => {
  const response = await api.post<PromotionCode>('/promotion-codes', dto);
  return response.data;
};

export const validatePromotionCode = async (code: string): Promise<PromotionCodeValidation> => {
  const response = await api.get<PromotionCodeValidation>(`/promotion-codes/${code}/validate`);
  return response.data;
};

export const deactivatePromotionCode = async (id: string): Promise<void> => {
  await api.delete(`/promotion-codes/${id}`);
};

export const activatePromotionCode = async (id: string): Promise<void> => {
  await api.post(`/promotion-codes/${id}/activate`);
};

export const getPromotionCodeByCode = async (code: string): Promise<PromotionCode> => {
  const response = await api.get<PromotionCode>(`/promotion-codes/${code}`);
  return response.data;
};



